"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serviceUrlsContext = void 0;
var _react = require("react");
const serviceUrlsContext = exports.serviceUrlsContext = /*#__PURE__*/(0, _react.createContext)({});
